const DEFAULT_HANDOFF_TIMEOUT_MS = 5000;
const DEFAULT_HANDOFF_POLL_MS = 50;

const safeNumber = (value, fallback = 0) => {
  const number = Number(value);
  return Number.isFinite(number) && number >= 0 ? number : fallback;
};

const createPlaybackHandoff = ({ entity, sample, wasPlaying = false, source = 'inline-youtube-player' }) => ({
  sessionId: `${entity.type}:${entity.id}:${Date.now()}`,
  mediaId: entity.id,
  mediaType: entity.type,
  source,
  target: 'playblock-youtube-player',
  position: safeNumber(sample?.position),
  duration: safeNumber(sample?.duration),
  wasPlaying: Boolean(wasPlaying),
  transferredAt: new Date().toISOString(),
  transferReason: 'continue-in-player',
  suppressResumeNotice: true,
});

const applyPlayBlockHandoff = ({
  playerRef,
  handoff,
  timeoutMs = DEFAULT_HANDOFF_TIMEOUT_MS,
  pollMs = DEFAULT_HANDOFF_POLL_MS,
  setTimer = window.setTimeout,
  clearTimer = window.clearTimeout,
  now = Date.now,
}) => new Promise((resolve) => {
  const startedAt = now();
  let timerId = null;

  const finish = (result) => {
    if (timerId) clearTimer(timerId);
    resolve(result);
  };

  const attempt = () => {
    const player = playerRef?.current;
    if (player && typeof player.seekTo === 'function') {
      try {
        player.seekTo(handoff.position, true);
        if (handoff.wasPlaying) {
          player.playVideo?.();
        } else {
          player.pauseVideo?.();
        }
        finish({ applied: true, position: handoff.position, wasPlaying: handoff.wasPlaying });
        return;
      } catch {}
    }

    if (now() - startedAt >= timeoutMs) {
      finish({ applied: false, reason: 'timeout' });
      return;
    }

    timerId = setTimer(attempt, pollMs);
  };

  // Let playYouTube finish loading the requested media before touching the shared ref.
  timerId = setTimer(attempt, 0);
});

export {
  DEFAULT_HANDOFF_POLL_MS,
  DEFAULT_HANDOFF_TIMEOUT_MS,
  applyPlayBlockHandoff,
  createPlaybackHandoff,
};
